import React from 'react';
import axios from 'axios';
import { Box, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
const statusIcon = (status) => {
    switch (status) {
        case "done":
            return React.createElement(CheckCircleIcon, { fontSize: "small", sx: { color: '#2e7d32' } });
        default:
            return React.createElement(RadioButtonUncheckedIcon, { fontSize: "small", sx: { color: '#bdbdbd' } });
    }
};
const formatDate = (value) => {
    if (!value)
        return null;
    const text = value.trim();
    if (!text)
        return null;
    const shortDateLike = /^\d{1,2}\.\d{1,2}(\.\d{2,4})?$/;
    const rangeLike = /^\d{1,2}\.\d{1,2}(\.\d{2,4})?\s*[–-]\s*\d{1,2}\.\d{1,2}(\.\d{2,4})?$/;
    const listLike = /^\d{1,2}\.\d{1,2}(\.\d{2,4})?(?:\s*,\s*\d{1,2}\.\d{1,2}(\.\d{2,4})?)+$/;
    if (shortDateLike.test(text) || rangeLike.test(text) || listLike.test(text)) {
        return text;
    }
    const parsed = new Date(text);
    if (!isNaN(parsed.getTime())) {
        return parsed.toLocaleDateString("ru-RU", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    }
    return text;
};
const TechCardBlock = ({ token, fieldId, season }) => {
    const [stages, setStages] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    React.useEffect(() => {
        setLoading(true);
        setError(null);
        axios.get(`/techcard/dashboard/${fieldId}/${season}`, { headers: { Authorization: `Bearer ${token}` } })
            .then((response) => {
            var _a, _b;
            setStages((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.stages) !== null && _b !== void 0 ? _b : []);
        })
            .catch(() => setError('Не удалось загрузить технологическую карту'))
            .finally(() => setLoading(false));
    }, [fieldId, season, token]);
    if (loading) {
        return React.createElement(Typography, { variant: "caption", color: "text.secondary", sx: { p: 2, display: 'block' } }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043A\u0430\u0440\u0442\u044B\u2026");
    }
    if (error) {
        return React.createElement(Typography, { variant: "caption", color: "error", sx: { p: 2, display: 'block' } }, error);
    }
    const hasAnyItems = stages.some(s => s.items.length > 0);
    if (!hasAnyItems) {
        return (React.createElement(Box, { sx: { m: 1.5, p: 2, border: '1px dashed', borderColor: 'divider', borderRadius: 2, textAlign: 'center' } },
            React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0439 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442"),
            React.createElement(Typography, { variant: "caption", color: "text.secondary" }, "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043A\u0430\u0440\u0442\u0443 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u00AB\u0412\u043D\u0435\u0441\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445\u00BB")));
    }
    return (React.createElement(Stack, { spacing: 2, sx: { p: 1.5, backgroundColor: '#f7f9f7' } }, stages.filter(s => s.items.length > 0).map((stage) => (React.createElement(Box, { key: stage.key },
        React.createElement(Stack, { direction: "row", spacing: 0.75, alignItems: "center", sx: { mb: 0.75, px: 0.25 } },
            React.createElement(Box, { sx: { width: 4, height: 18, borderRadius: 2, backgroundColor: '#2e7d32' } }),
            React.createElement(Typography, { variant: "subtitle2", sx: { fontWeight: 700, color: '#24352a' } }, stage.label),
            React.createElement(Typography, { variant: "caption", color: "text.secondary" }, stage.items.length)),
        React.createElement(Box, { sx: { backgroundColor: '#fff', border: '1px solid #e2e8e3', borderRadius: 2, overflow: 'hidden', boxShadow: '0 1px 2px rgba(27, 62, 37, 0.04)' } }, stage.items.map((item) => {
            const date = formatDate(item.date);
            return (React.createElement(Stack, { key: item.id, direction: "row", spacing: 1, alignItems: "flex-start", sx: {
                    px: 1.25,
                    py: 1,
                    '&:not(:first-of-type)': { borderTop: '1px solid #eef2ee' },
                } },
                React.createElement(Box, { sx: { pt: 0.1, display: 'flex' } }, statusIcon(item.status)),
                React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                    React.createElement(Typography, { variant: "body2", sx: { fontWeight: 500, lineHeight: 1.35 } }, item.name),
                    item.volume && (React.createElement(Typography, { variant: "caption", color: "text.secondary", sx: { display: 'block', mt: 0.2, lineHeight: 1.3 } }, item.volume))),
                date && (React.createElement(Typography, { variant: "caption", sx: { whiteSpace: 'nowrap', mt: 0.1, px: 0.65, py: 0.2, borderRadius: 1, color: '#52675a', backgroundColor: '#edf3ee' } }, date))));
        })))))));
};
export default TechCardBlock;
